import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/32_painted_wall/32_painted_wall"
 * Contains 1 texture(s)
 */
export class Desktop32PaintedWallAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/32_painted_wall/32_painted_wall';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '32_painted_wall.jpg'
    ] as const;
}
